import axios from "axios";
import { useState, useEffect } from "react";
import {useAuth0} from "@auth0/auth0-react";

export function useServerStatus(intervalMs = 5000) {
    const [online, setOnline] = useState(true);
    const auth = useAuth0();


    useEffect(() => {
        if (auth.isLoading || !auth.isAuthenticated) {
            setOnline(true);
            return;
        }

        const pingServer = async () => {
            try {
                const token = await auth.getAccessTokenSilently();

                const res = await axios.head("/api/ApplicationUser/ping", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "X-Skip-Global-Error-Handler": "true"
                    }
                });

                console.log(res);
                setOnline(true);
            } catch (err) {
                setOnline(false);
            }
        };

        pingServer();

        const timer = setInterval(pingServer, intervalMs);
        return () => clearInterval(timer);
    }, [auth.getAccessTokenSilently, auth.isAuthenticated, auth.isLoading, intervalMs]);

    return online;
}
